import React, { useEffect, useState } from "react";
import { Input, Button, Row, Col, Typography } from "antd";
import { useForm, Controller } from "react-hook-form";

import Yup from "ValidationModels/localizedYup";

import { FormItem } from "Components/form";
import { Link } from "react-router-dom";
import { useLocation, useHistory } from "react-router";
import { ACTION_TYPES } from "Store/models/auth";
import "Styles/app.less";
import { useStoreActions, useStoreState } from "easy-peasy";
import { yupResolver } from "@hookform/resolvers";
import Fade from "react-reveal/Fade";

import building1 from "Assets/login/image/login-1.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const { Text } = Typography;

const LoginFormValidation = Yup.object().shape({
  email: Yup.string().email().required(),
  password: Yup.string().min(8).required(),
});

export default function Login({ ...props }) {
  const { control, handleSubmit, errors, formState } = useForm({
    resolver: yupResolver(LoginFormValidation),
  });

  let location = useLocation();
  let history = useHistory();

  const { login } = useStoreActions((store) => store.auth);
  const { isAuthenticated, process } = useStoreState((store) => store.auth);

  const loginFormSubmit = async (form) => {
    login(form);
  };

  useEffect(() => {
    if (isAuthenticated) {
      history.push(location?.state?.from || "/panel");
    }
  }, [isAuthenticated]);

  return (
    <Row className="split-page-wrapper">
      <Col xs={24} md={12} style={{ backgroundColor: "#a69d98" }}>
        <Fade right>
          <img
            src={building1}
            style={{
              position: "absolute",
              right: -40,
              bottom: -50,
              height: "50vh",
            }}
          />
        </Fade>
      </Col>
      <Col
        xs={24}
        md={12}
        className="form-wrapper start"
        style={{ backgroundColor: "#f2f2f2" }}
      >
        <div className="form">
          <Fade top cascade>
            <Text style={{ fontSize: 18 }}>Hoş Geldiniz</Text>
            <Text type={"secondary"}>Devam etmek için giriş yapın</Text>
            <form
              onSubmit={handleSubmit(loginFormSubmit)}
              style={{ margin: " 24px 0" }}
            >
              <FormItem error={errors.email}>
                <Controller
                  name="email"
                  control={control}
                  as={
                    <Input
                      placeholder="E-Posta"
                      prefix={<FontAwesomeIcon icon={["fas", "envelope"]} />}
                    />
                  }
                />
              </FormItem>
              <FormItem error={errors.password}>
                <Controller
                  name="password"
                  control={control}
                  as={
                    <Input.Password
                      placeholder="Password"
                      prefix={<FontAwesomeIcon icon={["fas", "key"]} />}
                    />
                  }
                />
              </FormItem>
              <FormItem>
                <Button
                  loading={process == ACTION_TYPES.SIGNIN_IN}
                  block
                  type="primary"
                  htmlType="submit"
                >
                  Giriş
                </Button>
              </FormItem>
            </form>
            <p>
              Hesabınız mı yok? <Link to="signup">&nbsp;Kayıt Olun</Link>
              <br />
              Şifrenizi mi unuttunuz?
              <Link to="forgot-password">&nbsp;Sıfırlayın</Link>
            </p>
          </Fade>
        </div>
      </Col>
    </Row>
  );
}
